import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import { ConfirmationModalService } from './confirmation-modal.service';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  constructor(
    private updates: SwUpdate,
    private modal: ConfirmationModalService
  ) {
    if (!updates.isEnabled) {
      console.log('Service Worker no está habilitado');
      return;
    }

    // Escuchar nuevas versiones detectadas por SW
    updates.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe(evt => this.showUpdateModal());

    // Check periódico (útil para localhost)
    this.forceUpdateCheck();
  }

  private showUpdateModal() {
    this.modal.confirm({
        title: '::NewVersionAvailable',
        message: '::UpdateVersion',
        confirmText: '::Update',
    }).subscribe(result => {
      if (result) {
        // Activar nueva versión y recargar correctamente la SPA
        this.updates.activateUpdate().then(() => {
          // Detectar si estamos en localhost
          const isLocal = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
          if (isLocal) {
            // Local: recargar a raíz para evitar 404 en http-server
            location.href = '/';
          } else {
            // Producción: recargar ruta actual (mantiene SPA)
            location.reload();
          }
        });
      }
    });
  }

  private forceUpdateCheck() {
    // Cada cierto tiempo revisa si hay update (solo para pruebas locales)
    setInterval(() => {
      this.updates.checkForUpdate()
        .then(() => console.log('Chequeo de actualización ejecutado'))
        .catch(err => console.error('Error al chequear update', err));
    }, 6000); // cada 60s
  }
}
